import { UseFormProps } from 'react-hook-form'
export const reactHookFormDefaultOptions: UseFormProps<any> = {
  mode: 'onTouched',
}
